import Reveal from "@/components/Reveal";
import { Target, Film, Crown, Zap } from "lucide-react";

const PILLARS = [
  {
    n: "01",
    icon: Target,
    title: "CAPTACIÓN",
    sub: "Visibilidad que genera oportunidades",
    desc: "Meta Ads y campañas pensadas para atraer a personas que de verdad quieren comprar o vender coche en tu zona. No buscamos formularios; buscamos conversaciones que puedan acabar en venta.",
    chips: ["Meta Ads", "Campañas", "Conversaciones", "Seguimiento"],
  },
  {
    n: "02",
    icon: Film,
    title: "CONTENIDO MULTICANAL",
    sub: "Contenido que construye percepción",
    desc: "Instagram, TikTok y YouTube con intención: entregas reales, importaciones, procesos, casos de clientes y consejos de compra. Contenido que enseña cómo trabajas y por qué pueden confiar en ti, para que dejes de ser un escaparate y pases a ser una marca.",
    chips: ["Instagram", "TikTok", "YouTube", "Reels", "Carruseles", "Vídeo largo"],
  },
  {
    n: "03",
    icon: Crown,
    title: "MARCA & POSICIONAMIENTO",
    sub: "Haz que te recuerden",
    desc: "Identidad, mensaje y presencia digital para que tu negocio se vea profesional, distinto y de fiar. El objetivo: que en tu zona piensen en ti primero cuando alguien quiere comprar, vender o cuidar su coche.",
    chips: ["Identidad visual", "Mensaje", "Autoridad", "Comunidad"],
  },
  {
    n: "04",
    icon: Zap,
    title: "AUTOMATIZACIÓN",
    sub: "Para que nada se pierda",
    desc: "La capa que sostiene todo lo anterior: respuestas, seguimiento y cualificación automatizados para que ninguna oportunidad se quede sin contestar mientras tú estás vendiendo.",
    chips: ["Respuestas 24/7", "Seguimiento", "Cualificación"],
  },
];

export default function System360() {
  return (
    <section id="sistema" data-testid="system-section" className="relative py-24 lg:py-32 border-t border-white/5">
      <div className="absolute inset-0 bg-radial-blue opacity-40 pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 md:px-8 relative">
        <Reveal>
          <div className="font-stencil text-xs text-[#00A0A0] tracking-widest mb-4">03 / EL SISTEMA</div>

          <div className="mb-10">
            <div className="inline-block px-5 py-2 border-y-2 border-[#FFD700]">
              <p className="font-stencil text-sm sm:text-base lg:text-lg text-white uppercase tracking-widest">
                SISTEMA FUELKERS <span className="text-[#FFD700]">—</span> DONDE OTROS FRENAN, TÚ ACELERAS.
              </p>
            </div>
          </div>

          <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-16">
            <h2 className="font-heading text-white text-4xl sm:text-5xl lg:text-6xl xl:text-7xl uppercase tracking-tight leading-[0.95] max-w-3xl">
              UN SISTEMA PARA
              <br />
              <span className="text-white/40">DEJAR DE PARECER</span>
              <br />
              <span className="font-stencil text-[#00A0A0]">UNO MÁS.</span>
            </h2>
            <p className="text-white/60 max-w-sm font-body text-base leading-relaxed">
              Cuatro piezas que se refuerzan entre sí. Por separado son marketing.
              Juntas, un sistema que convierte atención en confianza y confianza en conversaciones comerciales.
            </p>
          </div>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-px bg-white/10 border border-white/10">
          {PILLARS.map((p, i) => (
            <Reveal key={p.n} delay={i * 100}>
              <div data-testid={`pillar-${i}`} className="group relative h-full bg-[#0a0a0a] p-8 lg:p-10 hover:bg-[#0f0f0f] transition-colors duration-500">
                <div className="absolute top-8 right-8 font-stencil text-5xl text-white/[0.06]">{p.n}</div>

                <div className="w-14 h-14 bg-gradient-to-br from-[#00A0A0]/20 to-transparent border border-[#00A0A0]/40 flex items-center justify-center mb-8 group-hover:border-[#FFD700]/60 transition-colors">
                  <p.icon className="w-6 h-6 text-[#00A0A0] group-hover:text-[#FFD700] transition-colors" strokeWidth={1.75} />
                </div>

                <h3 className="font-stencil text-2xl lg:text-3xl text-white tracking-tight mb-2">{p.title}</h3>
                <div className="text-sm text-[#00A0A0] mb-6 font-body">{p.sub}</div>

                <p className="text-sm text-white/60 leading-relaxed font-body mb-8">{p.desc}</p>

                <div className="flex flex-wrap gap-2 pt-6 border-t border-white/8">
                  {p.chips.map((c) => (
                    <span key={c} className="text-[10px] uppercase tracking-widest px-2.5 py-1 border border-white/15 text-white/65 font-body">
                      {c}
                    </span>
                  ))}
                </div>

                <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#00A0A0] to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
